import { defineMessages } from 'react-intl';

export default defineMessages({
  newHF: 'New health factor',
  safer: 'Safer',
  riskier: 'Riskier',
});
